import { axiosV3 } from "../../../Utils/Axios/axiosV3";

export const createNewTicketAndSendToServerService = async (
  userToken: string,
  files: any[],
  text: string,
  title: string,
  ticketSubjectId: number | string
) => {
  const data = new FormData();

  data.append("text", text);
  data.append("title", title);
  data.append("ticket_subject_id", String(ticketSubjectId));

  if (files.length > 0) {
    for (let i = 0; i <= files.length - 1; i++) {
      data.append("files[]", files[i].value);
    }
  }

  return axiosV3.post("/user/ticket/store", data, {
    headers: {
      Authorization: `Bearer ${userToken}`,
    },
  });
};
